import React from "react";
import GamePageTemplate from "./GamePageTemplate";

export const SearchPage = () => {
  return (
    <GamePageTemplate
      pageTitle="Search Games"
      bannerTitle="Search Games"
      bannerImage="/images/roulette-wide.jpg"
      showGameTypeFilter={true}
    />
  );
};

export default SearchPage;
